<template>
  <a-skeleton :active="active" :avatar="avatar" :loading="loading" :paragraph="paragraph" :title="title" />
</template>

<script>
export default {
  name: "HSkeleton",
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    avatar: {
      type: [Boolean, Object],
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    paragraph: {
      type: [Boolean, Object],
      default: true,
    },
    title: {
      type: [Boolean, Object],
      default: true,
    },
  },
};
</script>
